import MobileNav from "./components/MobileNav";
import Header from "./components/Header";
import Cotton from "./sections/Cotton";
import Sugar from "./sections/Sugar";
import About from "./sections/About";
import Contact from "./sections/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <MobileNav
        aboutText="About"
        contactText="Contact"
      />
      <Header
        webTitle="Fund Marketing International"
        aboutText="About"
        contactText="Contact"
      />
      <Cotton/>
      <Sugar/>
      <About/>
      <Contact/>
      <Footer/>
    </>
  );
}

export default App;